import { render } from "./TheFooterContact.vue?vue&type=template&id=c8018e90&scoped=true&ts=true"
import script from "./TheFooterContact.vue?vue&type=script&lang=ts"
export * from "./TheFooterContact.vue?vue&type=script&lang=ts"

import "./TheFooterContact.vue?vue&type=style&index=0&id=c8018e90&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8018e90"]])

export default __exports__